import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { BaseClass } from '../../utility/baseClass';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { EntitytypeService } from '../../main-layout/entitytype/entitytype.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-entitytypemodal',
  templateUrl: './entitytypemodal.component.html',
  styleUrls: ['./entitytypemodal.component.css']
})
export class EntitytypemodalComponent extends BaseClass implements OnInit {
  CSRFToken = '';
  saveTitle = 'Add'
  EntitytypeForm: FormGroup;
  onlyView: any;
  tempentitytype: any;
  isEdit: boolean = false;
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]
  existingdetails: any = {}

  verticalList: Array<any> = [];
  constructor(
    private entitytypeService: EntitytypeService,
    private fb: FormBuilder,
    public router: Router,
    public override  injector: Injector,
    private spinnerservice: NgxSpinnerService,
    public ref: DynamicDialogRef, private entitytypeservice: EntitytypeService,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice,
    private el: ElementRef
  ) {
    super(injector);
    this.gettoken();
    const dataFromParent = this.config.data;
    if (dataFromParent?.title == 'Modify Entity Type') {
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.existingdetails = dataFromParent.datas;
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData();
  }

  getData() {
    this.patchValueForms(this.existingdetails[0])
  }

  public validation_message = {
    'companytype': [
      { type: 'required', message: 'Entity Type is required.' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: "Special character not allowed (% and ')" }
    ]
  }
  patchValueForms(data) {
    this.EntitytypeForm.patchValue({
      'companytype': data?.companytype
    });
  }
  dismiss() {
    // Swal.fire({
    //   title: "Are you sure to close?",
    //   showDenyButton: true,
    //   showCancelButton: false,
    //   confirmButtonText: "No",
    //   denyButtonText: `Yes`
    // }).then((result) => {
    //   if (result.isDenied) {
        this.ref.close();
    //   }
    // });
  }
  formInitiliaze() {
    this.EntitytypeForm = this.fb.group({
      companytype: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)
      ])],
      id: []
    })
  }


  addEntitytype() {
    console.log(this.EntitytypeForm, "form");
    console.log(this.EntitytypeForm.invalid);

    if (this.EntitytypeForm.invalid) {
      this.validateAllFormFields(this.EntitytypeForm, this.el);
    }

    else if (this.saveTitle == 'Modify') {
      this.modifyEntitytype(this.EntitytypeForm.value)
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          let data = this.EntitytypeForm.value;
          data['csrftoken'] = this.CSRFToken;
          this.spinnerservice.show()
          this.entitytypeservice.postentitytype(this.EntitytypeForm.value).subscribe((data) => {
            this.tempentitytype = data;
            this.spinnerservice.hide();
            if (this.tempentitytype.response == 'exists') {
              Swal.fire("Entity Type already exists!", "", "error").then(result => {
              });
            } else {
              this.spinnerservice.hide();
              Swal.fire("Entity Type added successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error => {
            this.spinnerservice.hide();
            Swal.fire("Error!", error.error.response, "error");
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
    }
  }


  modifyEntitytype(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          const payload = { csrftoken: this.CSRFToken, entitytypename: this.EntitytypeForm.value.companytype, id: this.existingdetails[0].id };
          this.entitytypeservice.modifyentitytype(payload).subscribe((data) => {
            this.tempentitytype = data;
            this.spinnerservice.hide();
            if (this.tempentitytype.response == 'exists') {
              Swal.fire("Entity Type already exists!", "", "error").then(result => {
              });
            } else {
              this.spinnerservice.hide();
              Swal.fire("Entity Type modified successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error => {
            this.spinnerservice.hide();
            Swal.fire("Error!", error.error.response, "error");
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
        }
      });
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
}
